import {
  getModule,
  Module,
  VuexModule,
  MutationAction
} from "vuex-module-decorators";
import store from "@/store";
import { isSuccess } from "@/api/response";
import { ShopIdRequest } from "@/api/light-report/request";
import { GetStatusResponse } from "@/api/light-report/response";
import * as LightReport from "@/api/light-report";

const MODULE_NAME = "light-report-status/get";

/**
 * 帳票（軽量版）種別取得（/get-light-report-type）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Get extends VuexModule {
  // state
  getResponse: GetStatusResponse = {} as GetStatusResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.getResponse);
  }

  get getMessage() {
    return this.getResponse.message;
  }

  get getReportStatus() {
    if (this.getResponse.results) {
      return this.getResponse.results.status;
    } else {
      return 1;
    }
  }

  get getShopName() {
    if (this.getResponse.results) {
      return this.getResponse.results.shopName;
    } else {
      return null;
    }
  }

  // MutationActions
  @MutationAction
  async get(getRequest: ShopIdRequest) {
    const getResponse = await LightReport.getStatus(getRequest);
    return {
      getResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      getResponse: {} as GetStatusResponse
    };
  }
}

export default getModule(Get);
